import { toast } from 'react-toastify';

export function showToastMessageError(msg) {
    const toastError = toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-error-container toast-error-container-after'
    });

    return toastError;
};